import { createContext } from "react";

const ClearOnchangeContext = createContext([]);

export default ClearOnchangeContext;